<template lang="html">
  <div>
    <div id="html" >
      <div class="share-container" id="shareImg">
        <div class="bg">
          <img src="~mobile/pic/shareWx/logo_w.png" class="logo"/>
          <div class="content-bg">
            <div class="content">
              <div class="title">{{ map_title }}</div>
              <div class="summary" v-html="map_summary"></div>
              <div class="logo-area">
                <div class="length1" :class="{'length2': map_list.length >= 2 && (index == 0 || index == 1)}" v-for="(fa, index) in map_list" :key="index">
                  <div class="arr-title">
                    <img class="left" :src="$store.state.static_img_url + 'mobile/pic/shareMap/left.png'"></img>
                    <div class="text">{{fa.name}}</div>
                    <img class="right" :src="$store.state.static_img_url + 'mobile/pic/shareMap/right.png'"></img>
                  </div>
                  <div class="logos">
                    <div class="img-div" v-for="(logo, logo_index) in fa.arr" :key="logo.logo_path">
                      <img class="logo" :src="logo.logo_base64">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-footer">数据来源：动脉橙产业智库</div>
          <div class="footer">
            <img :src="xcx_code" />
            <p>进入小程序，查看更多详情</p>
          </div>
        </div>
      </div>
    </div>
    <div id="img">
      <img :src="imgbase" />
    </div>
    <div class="loading_img" v-if="loading">
      <div class="con"><span class="loader-box"></span><br><p>图片生成中</p></div>
    </div>
  </div>
</template>

<script>
import { share } from 'mobile/js/wx_share'
import html2canvas from 'html2canvas'
import { getMapById, wxShare, getdgxcxcode } from '../service'
import { sortKeyAsc } from 'mobile/js/common'
export default {
  data() {
    return {
      loading: true,
      map_title: '',
      map_summary: '',
      map_list: [],
      imgbase: '',
      xcx_code: '',
      finish_length: 0,
      finish_num: 0
    }
  },
  computed: {
    is_finish() {
      return this.finish_num == this.finish_length
    }
  },
  methods: {
    async getMapById() {
      let res = await getMapById({
        map_id: this.$route.params.map_id
      }, (error) => {this.$Message.error('请求错误！')})
      if (res.status == 'success') {
        this.map_title = res.res[0].title
        this.map_summary = res.res[0].unsign_summary
        this.finish_length = res.res[0].content.filter((item) => { return item.pid == null }).length
        let temp_fa = res.res[0].content.filter((item) => { return item.pid == null })
        this.subGroup(temp_fa)
        // sortKeyAsc(this.subGroup(temp_fa), 'sort_num')
        // this.map_list = sortKeyAsc(this.subGroup(temp_fa), 'sort_num')
        // console.log(this.map_list)
        // this.$set(this.$data, 'map_list', sortKeyAsc(this.map_list, 'sort_num'))
        this.$nextTick(() => {
          this.mapShare()
        })
      } else {
        this.$Message.error(res.message)
      }
    },
    subGroup(a) { // 分组
      // let temp_content = []
      for(let j of a) {
        let image = new Image()
        image.setAttribute('crossOrigin', 'anonymous')
        image.src = this.$store.state.img_req_url + j.logo_path
        image.onload = () => { // 网络图片请求成功
          j.logo_base64 = this.getBase64Image(image)
          let obj = this.map_list.find((item) => item.module_id == j.module_id)
          if (obj) {
            obj.arr.push(j)
          } else {
            this.map_list.push({
              name: j.module_name,
              module_id: j.module_id,
              sort_num: parseInt(j.sort_num),
              arr: [j]
            })
          }
          this.finish_num++
          if (this.finish_num == this.finish_length) {
            this.getXcxCode()
          }
        }
        image.onerror = () => { // 网络图片请求失败
          j.logo_base64 = this.$store.state.static_img_url+'pic/default-logo.png'
          let obj = this.map_list.find((item) => item.module_id == j.module_id)
          if (obj) {
            obj.arr.push(j)
          } else {
            this.map_list.push({
              name: j.module_name,
              module_id: j.module_id,
              sort_num: parseInt(j.sort_num),
              arr: [j]
            })
          }
          this.finish_num++
          if (this.finish_num == this.finish_length) {
            this.getXcxCode()
          }
        }
      }
      // return temp_content
    },
    toImg() {
      html2canvas(document.getElementById('shareImg'),{ scale: 1, useCORS: true, logging: false}).then((canvas) => {
        let save_url= canvas.toDataURL("image/png")
        this.$set(this.$data, 'imgbase', save_url)
        this.loading = false
      })
    },
    async mapShare() {
      let res = await wxShare({"url":this.$store.state.req_url+"/mindex" + this.$route.fullPath},
        (error) => { this.$Message.error('请求错误!') }
      )
      share(res, {
        title: this.map_title,
        desc: this.map_summary,
        link: this.req_url + '/mindex' + this.$route.fullPath,
        imgUrl: this.$store.state.req_url+'/share_pro.png'
      }, this, window.location.href)
    },
    getBase64Image(img) {
      var canvas = document.createElement("canvas")
      canvas.width = img.width
      canvas.height = img.height
      var ctx = canvas.getContext("2d")
      ctx.drawImage(img, 0, 0, img.width, img.height)
      var dataURL = canvas.toDataURL("image/png")  // 可选其他值 image/jpeg
      return dataURL;
    },
    async getXcxCode() {
      let res = await getdgxcxcode({
        page: 'pages/themeDetail/themeDetail',
        scene: this.$route.query.theme_uid
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.xcx_code = 'data:image/png;base64,' + res.info
        this.toImg()
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  created() {
    this.getMapById()
  },
  watch: {
    is_finish(val) {
      if (val) {
        sortKeyAsc(this.map_list, 'sort_num')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~mobile/styles/shareLoading.stylus'
@import '~mobile/styles/shareWx.stylus'
#html
  overflow: hidden
  height: 0
  width: 0
#img img
  width: 100%
  display: block
.logo-area
  margin-top: 20px
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  background-image: url('~pic/watermark-gray.png');
  position: relative;
  .length1
    grid-column-start: span 4;
    border: 1px dashed #FFB87C;
    border-radius: 10px;
    margin-top: 24px;
    position: relative;
    .arr-title
      display: inline-flex;
      position: absolute;
      top: -16px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      justify-content: center;
      align-items: center;
      .left,.right
        width: 39px;
        height: 19px;
        background-color: #FFFFFF
      .left
        margin-right: -1px
      .right
        margin-left: -1px
      .text
        color: #333333;
        font-size: 28px;
        padding: 0 10px;
        display: flex;
        align-items: center;
        font-weight: bold;
        background-color: #FFFFFF
    .logos
      display: grid;
      grid-gap: 20px;
      padding: 64px 40px 40px;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    .img-div
      width: 100px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      img
        max-height: 100%;
        max-width: 100%;
    .open
      text-align: center;
      color: #FA5A00;
      font-size: 28px;
      margin-bottom: 24px;
      i
        font-size: 20px;
  .length2
    grid-column-start: span 2;
    .logos
      grid-template-columns: 1fr 1fr;
  >img
    position: absolute;
    right: 40px;
    top: -130px;
    width: 110px;
</style>
